export const OPCOES_PRECISAO = [
  'Grau de Precisão I',
  'Grau de Precisão II',
  'Grau de Precisão III',
];

export const OPCOES_FUNDAMENTACAO = [
  'Grau de Fundamentação I',
  'Grau de Fundamentação II',
  'Grau de Fundamentação III',
];

export const formatarMoeda = (valor: number): string => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(valor);
};

export const formatarArea = (valor: number): string => {
  return new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(valor);
};
